if (!customElements.get('product-item')) {
  class ProductItem extends HTMLElement {
    constructor() {
      super();

      this.data = this.dataset;

      document.querySelectorAll(".product-item__content details").forEach((detail, index) => {
        if (window.matchMedia("(min-width: 1024px)").matches) {
          detail.setAttribute("open", ""); // Force details to stay open on desktop
          detail.setAttribute("disabled", "");
          let summary = detail.querySelector("summary");
          if (summary) {
            summary.addEventListener("click", function (e) {
              e.preventDefault(); // Prevents toggle, but not clicks inside <details>
            });
          }
        } else {
          detail.removeAttribute("disabled");

          if (index === 0) {
            detail.setAttribute("open", "");  // Force the first detail to stay open on mobile
          } else {
            detail.removeAttribute("open"); // Close all other details
          }
        }
      });
    }
  }
  customElements.define('product-item', ProductItem);
}
